import React from 'react';

// A punchy copper headline-quote that sits above a section's content.
function SectionQuote({ children }) {
  return <p className="section-quote">{children}</p>;
}

export default SectionQuote;
